import { IModel } from "@/@types/models/model";
import { coreFields } from "@/models/helpers/coreFields";
import { commonFields } from "./helpers/commonFields";
import { routingFields } from "./helpers/routingFields";

const IzletDan: IModel = {
  title: "Izlet dan",
  apiPath: "hps/izleti/{id}/dani",
  httpUpdateVerb: "put",
  forms: {
    hps: {
      fields: ["dan", "standard_id", "opis"],
    },
    reg: {
      fields: [{ source: "dan", width: 'full'}, "opis"],
    },
    korisnik: {
      fields: [{ source: "dan", width: 'full'}, "opis"],
    },
  },
  listViews: {
    default: {
      fields: ["id"],
    },
    hps: {
      fields: ["id", "dan", "datum", "dan_u_tjednu", "standard_id", "opis", 'total_length', 'total_time_min', 'total_ascent', 'total_descent' ],
      hidden: ["id"],
    },
    reg: {
      fields: ["id", "dan", "datum", "dan_u_tjednu", "opis", 'total_length', 'total_time_min', 'total_ascent', 'total_descent'],
      hidden: ["id"]
    },
    korisnik: {
      fields: ["id", "dan", "datum", "dan_u_tjednu", "opis", 'total_length', 'total_time_min', 'total_ascent', 'total_descent'],
      hidden: ["id"]
    },
    // TODO expand with variants
  },
  fields: [
    coreFields.id,
    commonFields.wkt,
    {
      title: "Standard",
      source: "standard_id",
      ttoken: "hps.izleti.standard",
      type: "picker",
      items: {
        labels: ["hps.vodicki_standardi.a","hps.vodicki_standardi.b","hps.vodicki_standardi.c","hps.vodicki_standardi.d","hps.vodicki_standardi.e","hps.vodicki_standardi.f","hps.vodicki_standardi.g"],
        values: [10, 20, 30, 40, 50, 60, 70],
        default: 10,
      },
      validation: {
        required: true,
      },
      translate: true,
      tooltip: "hps.izleti.standard_tooltip"
    },
    {
      title: "Dan",
      source: "dan",
      ttoken: "common.dan",
      type: "wholenum",
      validation: {
        required: true,
        maxValue: 30
      },
      tooltip: "hps.izleti.dan_tooltip"
    },
    {
      title: "Datum",
      source: "datum",
      ttoken: "common.datum",
      type: "date",
      readonly: true
    },
    {
      title: "Dan u tjednu",
      source: "dan_u_tjednu",
      ttoken: "common.dan_u_tjednu",
      type: "text",
      readonly: true,
      translate: true
    },
    {
      title: "opis",
      source: "opis",
      ttoken: "hps.izleti.plan_izleta_za_dan",
      type: "multiline",
      rows: "15",
      validation: {
        maxLength: 4000,
      },
      width: "full",
      tooltip: "hps.izleti.opis_tooltip"
    },
    {
      title: "Točke rutiranja",
      source: "route_points",
      ttoken: "common.route_points",
      type: "array",
      readonly: true
    },
    {
      title: "FLAG - Ima li rutu",
      source: "has_route",
      ttoken: "hps.izleti.has_route",
      type: "boolean",
      readonly: true
    },
    routingFields.total_length,
    routingFields.total_time_min,
    routingFields.total_ascent,
    routingFields.total_descent,
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
  ],
};

export default IzletDan;
